<div mat-dialog-title
  class="dialog-header d-flex justify-content-between align-items-center bg-light p-3 border-bottom">
  <div class="d-flex align-items-center">
    <button *ngIf="calendarioSelezionato && !loading" class="btn btn-icon btn-xs me-2" (click)="tornaAllaLista()"
      matTooltip="Torna alla lista calendari">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <h2 class="h5 mb-0 text-primary fw-bold">
      {{ calendarioSelezionato ? calendarioSelezionato.nome : 'Selezione Calendario Disponibilità' }}
    </h2>
  </div>
  <button type="button" class="btn-close" (click)='chiudi()'></button>
</div>

<mat-dialog-content class="p-0 d-flex flex-column" style="overflow: hidden !important;">

  <div *ngIf="!calendarioSelezionato && !loading" class="selection-container container-fluid py-4 bg-light"
    style="overflow-y: auto; flex: 1;">
    <div class="row g-4 justify-content-center">
      <div class="col-12 col-md-6 col-lg-4 d-flex" *ngFor="let cal of listaCalendari">
        <mat-card appearance="outlined" class="w-100 shadow-sm selection-card h-100 border-primary-subtle">
          <mat-card-header>
            <mat-icon mat-card-avatar color="primary">event_available</mat-icon>
            <mat-card-title class="text-primary h6 fw-bold">{{ cal.nome }}</mat-card-title>
          </mat-card-header>

          <mat-card-content class="mt-3 flex-grow-1">
            <p class="text-muted small">{{ cal.note || 'Visualizza gli slot disponibili per questo calendario.' }}</p>
          </mat-card-content>

          <mat-card-content class="mt-3 flex-grow-1">
            <p class="text-muted small">{{ cal.nomeStruttura ? 'Struttura: ' + cal.nomeStruttura : 'Nessuna struttura associata' }}</p>
          </mat-card-content>

          <mat-card-actions align="end" class="p-3">
            <button class="btn btn-primary btn-sm px-4" (click)="selezionaCalendario(cal)">
              APRI
            </button>
          </mat-card-actions>
        </mat-card>
      </div>

      <div class="col-12 text-center py-5" *ngIf="listaCalendari.length === 0">
        <mat-icon class="text-muted" style="font-size: 48px; width: 48px; height: 48px;">event_busy</mat-icon>
        <p class="text-muted mt-2">Nessun calendario disponibile per questo operatore.</p>
      </div>
    </div>
  </div>

  <div *ngIf="loading" class="d-flex flex-column justify-content-center align-items-center flex-grow-1">
    <div class="progress-spinner progress-spinner-active">
      <span class="visually-hidden">Caricamento...</span>
    </div>
    <span class="mt-3 text-primary fw-semibold">Caricamento in corso...</span>
  </div>

  <div *ngIf="calendarioSelezionato" class="calendar-main-container flex-grow-1 d-flex flex-column p-3"
    [class.calendar-hidden]="loading">
    <div style="flex: 1; min-height: 0;">
      <full-calendar #calendar [options]="calendarOptions"></full-calendar>
    </div>
  </div>

</mat-dialog-content>

<mat-dialog-actions align="end" class="p-3 bg-light border-top justify-content-between">

  <div>
    <button class="btn btn-outline-secondary btn-sm" (click)="chiudi()">
      {{ slotSelezionati.length > 0 ? 'Annulla' : 'Chiudi' }}
    </button>
  </div>

  <div *ngIf="slotSelezionati.length > 0" class="d-flex align-items-center animate__animated animate__fadeInRight">
    <div class="text-end me-3">
      <div class="text-primary fw-bold small">
        {{ slotSelezionati.length }} {{ slotSelezionati.length === 1 ? 'slot selezionato' : 'slot selezionati' }}
      </div>
      <div class="text-muted" style="font-size: 0.75rem;">
        {{ slotSelezionati[0].start | date:'HH:mm' }} - {{ slotSelezionati[slotSelezionati.length-1].end | date:'HH:mm'
        }}
      </div>
    </div>

    <button class="btn btn-outline-danger btn-sm me-2" (click)="cancellaSelezione()" matTooltip="Pulisci selezione">
      <mat-icon style="font-size: 18px; width: 18px; height: 18px;">delete_sweep</mat-icon>
    </button>

    <button class="btn btn-success btn-sm px-4 fw-bold shadow-sm" (click)="confermaPrenotazioneMultipla()">
      PRENOTA ORA
    </button>
  </div>

</mat-dialog-actions>